import BASE_RULE from '../baseRule';
import {SearchTypeDate, DateType, DateSubType} from './constants';
import {DateRule} from './types';

export const dateRuleDefaults: DateRule = {
	...BASE_RULE,
	elementType: SearchTypeDate,
	elementSubType1: DateType.CREATION_DATE,
	elementSubType2: DateSubType.TODAY,
};

export default dateRuleDefaults;
